var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"todo"},[_c('list-caption',{staticClass:"layout-caption",attrs:{"caption":"今日やること","icon":"sync-alt","action":_vm.reset}}),_c('habit-list',{staticClass:"layout-habit-list"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }